export default __webpack_public_path__ + "static/Image_Free_3-f1c2fddb8feebf70e6d782dbd2ea8f47.png";